import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {UnansweredQuestionsDialogComponent} from '../unanswered-questions-dialog/unanswered-questions-dialog.component';

@Component({
  selector: 'app-csv-dialog',
  templateUrl: './csv-dialog.component.html',
  styleUrls: ['./csv-dialog.component.css']
})
export class CsvDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<UnansweredQuestionsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public dialogData: any) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

}
